import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { ComparisonExpression, Conditional, Expression, FieldAction, Predicate } from "./model";
import { FormDefinition } from "../vforms-model";
import { ConditionalComponent } from "./conditional/conditional.component";
import { assign } from "lodash-es";

@Component({
    selector: "conditional-settings",
    templateUrl: "./conditional-settings.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConditionalSettingsComponent {
    formDefinition: FormDefinition;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private _dialog: MatDialog,
        private _changeDetector: ChangeDetectorRef
    ) {
        this.formDefinition = this.data.form;
    }

    add() {
        let dialogRef = this._dialog.open(ConditionalComponent, {
            data: {
                form: this.formDefinition,
                conditional: new Conditional(),
            },
        });

        dialogRef.afterClosed().subscribe((conditional) => {
            if (conditional) {
                this.formDefinition.addConditional(conditional);
                this._changeDetector.markForCheck();
            }
        });
    }

    edit(conditional: Conditional) {
        let dialogRef = this._dialog.open(ConditionalComponent, {
            data: {
                form: this.formDefinition,
                conditional: assign(new Conditional(), {
                    name: conditional.name,
                    predicate: assign(new Predicate(), {
                        expressions: conditional.predicate.expressions.map((e) =>
                            assign(new Expression(), {
                                conditions: e.conditions.map((c) => assign(new ComparisonExpression(), c)),
                            })
                        ),
                    }),
                    positiveActions: conditional.positiveActions.map((a) => assign(new FieldAction(), a)),
                    negativeActions: conditional.negativeActions.map((a) => assign(new FieldAction(), a)),
                }),
            },
        });

        dialogRef.afterClosed().subscribe((updated) => {
            if (updated) {
                assign(conditional, updated);
                this._changeDetector.markForCheck();
            }
        });
    }

    onDrop(event) {
        this.formDefinition.conditionals.splice(
            event.currentIndex,
            0,
            ...this.formDefinition.conditionals.splice(event.previousIndex, 1)
        );
    }

    remove(conditional: Conditional) {
        this.formDefinition.conditionals.splice(this.formDefinition.conditionals.indexOf(conditional), 1);
    }
}
